import state from "../state";

const Zoom = {
  OFF: 0,
  IN: 1,
  OUT: 2
}

const Move = {
  OFF: 0,
  FORWARD: 1,
  BACKWARD: 2
}

class UINavView {
  constructor() {
    this.dom = document.querySelector("#ui-nav");
    this.zooming = Zoom.OFF;
    this.moving = Move.OFF;

    const zoomInButton = this.dom.querySelector("#ui-zoom-in");
    const zoomOutButton = this.dom.querySelector("#ui-zoom-out");

    zoomInButton.addEventListener("mousedown", () => {
      this.zooming = Zoom.IN;
      this.zoomIn();
    });

    zoomInButton.addEventListener("mouseup", () => {
      this.zooming = Zoom.OFF;
    });

    zoomOutButton.addEventListener("mousedown", () => {
      this.zooming = Zoom.OUT;
      this.zoomOut();
    });

    zoomOutButton.addEventListener("mouseup", () => {
      this.zooming = Zoom.OFF;
    });

    const moveForwardButton = this.dom.querySelector("#ui-move-forward");
    const moveBackwardButton = this.dom.querySelector("#ui-move-backward");

    moveForwardButton.addEventListener("mousedown", () => {
      this.moving = Move.FORWARD;
      this.moveForward();
    });

    moveForwardButton.addEventListener("mouseup", () => {
      this.moving = Move.OFF;
    });

    moveBackwardButton.addEventListener("mousedown", () => {
      this.moving = Move.BACKWARD;
      this.moveBackward();
    });

    moveBackwardButton.addEventListener("mouseup", () => {
      this.moving = Move.OFF;
    });
  }

  zoomIn() {
    if (this.zooming === Zoom.IN) {
      state.channel.publish("onZoomIn");
      window.requestAnimationFrame(this.zoomIn.bind(this));
    }
  }

  zoomOut() {
    if (this.zooming === Zoom.OUT) {
      state.channel.publish("onZoomOut");
      window.requestAnimationFrame(this.zoomOut.bind(this));
    }
  }

  moveForward() {
    if (this.moving === Move.FORWARD) {
      state.channel.publish("onMoveForward");
      window.requestAnimationFrame(this.moveForward.bind(this));
    }
  }

  moveBackward() {
    if (this.moving === Move.BACKWARD) {
      state.channel.publish("onMoveBackward");
      window.requestAnimationFrame(this.moveBackward.bind(this));
    }
  }
}

export default UINavView;
